

















































































































































































import { Vue, Component } from 'vue-property-decorator';
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";

enum ProductEnum {
  CloudZirve = 1,
  ArabulucuPro = 2,
  DavaPro = 3,
  Sso = 4,
  Imza = 5,
  WebSayfasi = 6,
  OdemeLinki = 7,
  Admin = 8,
}

@Component({
  components: { EnabledSwitch }
})
export default class BilgilendirmeListesi extends Vue {
  ProductEnum = ProductEnum;
  bilgilendirmeler: any[] = [];
  loading = false;
  dialog = false;
  menu = false;
  editingId: number | null = null;

  form = {
    bilgi_type: null as number | null,
    product: [] as any[],
    programda_gozuksun: 0,
    bilgi_baslik: '',
    bilgi_metin: '',
    aktif: 0,
    bilgi_tarih: ''
  };

  headers = [
    { text: 'ID', value: 'bilgilendirme_id' },
    { text: 'Başlık', value: 'bilgi_baslik' },
    { text: 'Ürün', value: 'product' },
    { text: 'Programda Gözüksün', value: 'programda_gozuksun' },
    { text: 'Tarih', value: 'bilgi_tarih' },
    { text: 'Durum', value: 'aktif' },
    { text: 'İşlemler', value: 'actions', sortable: false }
  ];

  mounted() {
    this.getBilgilendirmeler();
  }

  async getBilgilendirmeler() {
    this.loading = true;
    try {
      let response = await this.$http.get("bilgilendirme");
      this.bilgilendirmeler = (response.data || []).map((d: any) => ({
        ...d,
        aktif: typeof d.aktif === 'string' ? Number(d.aktif) : d.aktif
      }));
    } catch (e) {
      console.error('Bilgilendirmeler alınamadı', e);
    } finally {
      this.loading = false;
    }
  }

  async saveBilgilendirme() {
    try {
      const selectedProducts = (this.form.product || []).map((pid: any) => {
        if (typeof pid === 'object' && 'value' in pid) {
          return { id: pid.value };
        }
        return { id: pid };
      });
      if (this.editingId !== null) {
        await this.$http.post(`/bilgilendirme/${this.editingId}`, {
          bilgi_type: this.form.bilgi_type,
          product: JSON.stringify(selectedProducts),
          programda_gozuksun: this.form.programda_gozuksun,
          bilgi_baslik: this.form.bilgi_baslik,
          bilgi_metin: this.form.bilgi_metin,
          aktif: this.form.aktif ? 1 : 0,
          bilgi_tarih: this.form.bilgi_tarih
        });
      } else {
        await this.$http.post('/bilgilendirme', {
          bilgi_type: this.form.bilgi_type,
          product: JSON.stringify(selectedProducts),
          programda_gozuksun: this.form.programda_gozuksun,
          bilgi_baslik: this.form.bilgi_baslik,
          bilgi_metin: this.form.bilgi_metin,
          aktif: this.form.aktif ? 1 : 0,
          bilgi_tarih: this.form.bilgi_tarih
        });
      }

      this.dialog = false;
      this.editingId = null;
      this.resetForm();
      this.getBilgilendirmeler();
    } catch (e) {
      console.error('Bilgilendirme kaydedilemedi', e);
    }
  }

  resetForm() {
    this.form = {
      bilgi_type: null,
      product: [],
      programda_gozuksun: 0,
      bilgi_baslik: '',
      bilgi_metin: '',
      aktif: 0,
      bilgi_tarih: ''
    };
  }

  async deleteBilgilendirme(id: number) {
    try {
      await this.$http.delete(`/bilgilendirme/${id}`);
      this.getBilgilendirmeler();
    } catch (e) {
      console.error('Bilgilendirme silinemedi', e);
    }
  }

  safeParseProducts(productData: any) {
    try {
      if (typeof productData === 'string') {
        const parsed = JSON.parse(productData);
        if (Array.isArray(parsed)) return parsed;
      } else if (Array.isArray(productData)) {
        return productData;
      }
    } catch (e) {
      console.error('Product JSON parse error:', e);
    }
    return [];
  }

  async updateBilgilendirme(item: any) {
    try {
      this.form.bilgi_type = item.bilgi_type;

      const parsedProducts = this.safeParseProducts(item.product);
      this.form.product = parsedProducts.map((p: any) => {
        if (p.id && typeof p.id === 'object' && 'value' in p.id && 'text' in p.id) {
          return { text: p.id.text, value: p.id.value };
        } else if (p.id && typeof p.id === 'number') {
          const productName = this.getProductName(p.id);
          return { text: productName, value: p.id };
        }
        return null;
      }).filter((v: any) => v !== null);

      this.form.programda_gozuksun = Number(item.programda_gozuksun) === 1 ? 1 : 0;
      this.form.bilgi_baslik = item.bilgi_baslik;
      this.form.bilgi_metin = item.bilgi_metin;
      this.form.aktif = Number(item.aktif) === 1 ? 1 : 0;
      this.$nextTick(() => {
        this.$forceUpdate();
      });
      this.form.bilgi_tarih = item.bilgi_tarih ? item.bilgi_tarih.slice(0, 10) : '';

      this.dialog = true;
      this.editingId = item.bilgilendirme_id;
    } catch (e) {
      console.error('Bilgilendirme yüklenemedi:', e);
    }
  }

  getProductName(id: number): string {
    switch (id) {
      case ProductEnum.CloudZirve: return 'Cloud Zirve';
      case ProductEnum.ArabulucuPro: return 'ArabulucuPro';
      case ProductEnum.DavaPro: return 'DavaPro';
      case ProductEnum.Sso: return 'Sso';
      case ProductEnum.Imza: return 'İmza';
      case ProductEnum.WebSayfasi: return 'Web Sayfası';
      case ProductEnum.OdemeLinki: return 'Ödeme Linki Ekranı';
      case ProductEnum.Admin: return 'Admin';
      default: return 'Bilinmiyor';
    }
  }

  getProductChipColor(name: string) {
    if (name === 'Cloud Zirve') {
      return { color: '#5A8DEE', textColor: 'white' }; // koyu pastel mavi
    }
    if (name === 'ArabulucuPro') {
      return { color: '#4CAF50', textColor: 'white' }; // koyu pastel yeşil
    }
    if (name === 'DavaPro') {
      return { color: '#E57373', textColor: 'white' }; // koyu pastel kırmızı
    }
    if (name === 'Sso') {
      return { color: '#FF8A65', textColor: 'white' }; // koyu pastel turuncu
    }
    if (name === 'İmza') {
      return { color: '#AED581', textColor: 'white' }; // koyu pastel açık yeşil
    }
    if (name === 'Web Sayfası') {
      return { color: '#B0BEC5', textColor: 'white' }; // koyu pastel gri
    }
    if (name === 'Ödeme Linki Ekranı') {
      return { color: '#9575CD', textColor: 'white' }; // pastel mor (ekstra)
    }
    if (name === 'Admin') {
      return { color: '#332e3b', textColor: 'white' }; // pastel mor (ekstra)
    }
    return { color: 'grey lighten-3', textColor: 'grey darken-3' };
  }
}
